import { useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchApplicationsAndQuestionnaires = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      const response = await apiGet("/aplicaciones/applications_and_questionnaires", "Error al obtener las aplicaciones y cuestionarios");
      setResponse(response);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, error, loading };
};

export default useFetchApplicationsAndQuestionnaires;
